module.exports = __webpack_public_path__ + "img/fca6.69b59d24.png";